// extracted by mini-css-extract-plugin
module.exports = {"selectedUser":"selectRetail_selectedUser__1zfX1","selectedUserName":"selectRetail_selectedUserName__3TlzA","avatar":"selectRetail_avatar__1wvzH"};